export default {"src":"/uk/_next/static/media/cloud-tick.e65f25aa.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};